import {
  Alert,
  Autocomplete,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { desc } from "../../../lib/chartDescription";
import { useRedditPropertyData } from "../../../lib/hooks";
import {
  listing_options,
  post_catergory_options,
  reddit_table_options,
  time_filter_options,
} from "../../../lib/twitterAPI";
import { roundNumber } from "../../../lib/util";
import styles from "./../../../styles/charts/chartStyle.module.css";
import AreaLineChart from "../protoCharts/AreaLineChart";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "../twitter/TwitterWordCloud";

interface TwitterPropertyProps {
  type?: "timeSeries" | "lineChart";
}

export const propertyNameOptionSet1RedditProperty = [
  "Number of Posts",
  "Mean Score",
  "Mean Ups",
  "Mean Downs",
  "Mean Comments",
];
export const propertyNameOptionSet2RedditProperty = [
  "Number of Comments",
  "Mean Score",
  "Mean Ups",
  "Mean Downs",
];

export default function RedditProperty(props: TwitterPropertyProps) {
  const { type = "lineChart" } = props;
  const [chartData, setChartData] = useState<{
    data: any[];
    labels: any[];
  } | null>(null);

  const [distribution, setDistribution] = useState<string[] | undefined>(
    undefined
  );

  const [postCategory, setpostCategory] = useState(post_catergory_options[0]);

  const [timeFilter, settimeFilter] = useState(time_filter_options[0]);

  const [listing, setListing] = useState(listing_options[0]);

  const [redditTable, setRedditTable] = useState(reddit_table_options[0]);

  // THis propertName will depend upon the value of reddit table selection
  // "property_name" (Required)
  // Options value according to reddit_table parameter
  // 	<|
  // 		RedditPosts->
  // 			{Number of Posts,Mean Score,Mean Ups,Mean Downs,Mean Comments}
  // 		RedditComments->
  // 			{Number of Comments,Mean Score,Mean Ups,Mean Downs}
  // 	|>
  const [propertyName, setpropertyName] = useState(
    redditTable === reddit_table_options[0]
      ? propertyNameOptionSet1RedditProperty[0]
      : propertyNameOptionSet2RedditProperty[0]
  );

  const { redditPropertyData, loading, error } = useRedditPropertyData(
    type === "lineChart"
      ? {
          reddit_table: redditTable,
          property_name: propertyName,
          group_by_year: true,
          create_keyword_items: true,
          group_by_month: false,
          create_year_items: false,
          time_filter: timeFilter,
          listing,
          post_category: postCategory,
        }
      : {
          reddit_table: redditTable,
          property_name: propertyName,
          group_by_year: true,
          create_keyword_items: true,
          group_by_month: true,
          create_year_items: true,
          time_filter: timeFilter,
          listing,
          post_category: postCategory,
        }
  );

  useEffect(() => {
    let dataForChart: any[] = [];
    let labels: any[] = [];
    if (loading) {
      setChartData({ data: [], labels: [] });
    }
    if (!loading && error === null) {
      if (type === "lineChart") {
        setDistribution([redditPropertyData[0].keyword]);
        redditPropertyData[0].items.forEach((item: any) => {
          dataForChart.push(roundNumber(item.value));
          labels.push(item.year.toString());
          // console.log(item);
        });
        setChartData({ data: dataForChart, labels });
      } else {
        setDistribution([redditPropertyData[0].keyword]);
        redditPropertyData[0].items.forEach((item: any) => {
          item.items.forEach((subItem: any) => {
            dataForChart.push({
              x: `${item.year}-${subItem.month}-01`,
              y: roundNumber(subItem.value),
            });
            // labels.push(`${item.year}-${subItem.month}-01`);
          });
          // console.log(item);
          // console.log(dataForChart);
        });
        let seriesData = [
          { name: redditPropertyData[0].keyword, data: dataForChart },
        ];
        // console.log(seriesData);
        setChartData({
          data: seriesData,
          labels: [],
        });
        // console.log([
        //   { name: redditPropertyData[0].keyword, data: dataForChart },
        // ]);
      }
    }
    // console.log(dataForChart);
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    let data: any[] = [];
    let labels: any[] = [];
    let seriesData: any[] = [];

    if (distribution !== undefined) {
      if (type === "lineChart") {
        if (Array.isArray(distribution)) {
          redditPropertyData
            .filter((item) => distribution.includes(item.keyword))
            .forEach((keys) => {
              data = [];
              keys.items.forEach((subItem: any) => {
                data.push({
                  x: subItem.year.toString(),
                  y: roundNumber(subItem.value),
                });
                // labels.push(item.year.toString());
                // console.log(item);
              });
              seriesData.push({ name: keys.keyword, data });
            });

          setChartData({ data: seriesData, labels });
        }
      } else {
        if (Array.isArray(distribution)) {
          redditPropertyData
            .filter((item) => distribution.includes(item.keyword))
            .forEach((keys) => {
              data = [];
              keys.items.forEach((item: any) => {
                item.items.forEach((subItem: any) => {
                  data.push({
                    x: `${item.year}-${subItem.month}-01`,
                    y: roundNumber(subItem.value),
                  });
                  // labels.push();
                });
                // console.log(item);
              });
              seriesData.push({ name: keys.keyword, data });
            });

          setChartData({ data: seriesData, labels });
        }
      }
    }

    // setChartData({ data, labels });
    //eslint-disable-next-line
  }, [distribution]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter" style={{ paddingRight: "20px" }}>
          <Typography
            className={styles.chartHeader}
          >{`${propertyName} of ${postCategory}`}</Typography>
        </div>
        <div className="horizontalCenter">
          <div className={styles.selectOptionRowWordCloud}>
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={reddit_table_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setRedditTable(newValue as string);
                newValue === reddit_table_options[0]
                  ? setpropertyName(propertyNameOptionSet1RedditProperty[0])
                  : setpropertyName(propertyNameOptionSet2RedditProperty[0]);
                // console.log(newValue);
              }}
              disableClearable
              value={redditTable as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Reddit Table"
                />
              )}
            />
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={post_catergory_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setpostCategory(newValue as string);
                // console.log(newValue);
              }}
              disableClearable
              value={postCategory as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Post Category"
                />
              )}
            />
            <Autocomplete
              // autoComplete
              fullWidth
              id="combo-box-demo"
              options={
                redditTable === reddit_table_options[0]
                  ? propertyNameOptionSet1RedditProperty
                  : propertyNameOptionSet2RedditProperty
              }
              // isOptionEqualToValue={(option, value) =>
              //   option.label === value.label
              // }
              // sx={{ width: "40%" }}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: any) => {
                // setValue(newValue);
                setpropertyName(newValue);
                // console.log(newValue);
              }}
              disableClearable
              value={propertyName}
              renderInput={(params) => (
                <TextField {...params} label="Select Property" />
              )}
            />
            {["Controversial Posts", "Top Posts", "Keyword Posts"].includes(
              postCategory
            ) && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={time_filter_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  settimeFilter(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={timeFilter as string}
                renderInput={(params) => (
                  <TextField {...params} label="Time Filter" />
                )}
              />
            )}
            {"Keyword Posts" === postCategory && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={listing_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setListing(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={listing as string}
                renderInput={(params) => (
                  <TextField {...params} label="Listing" />
                )}
              />
            )}
            {distribution && (
              <Autocomplete
                // autoComplete
                multiple={true}
                id="combo-box-demo"
                options={redditPropertyData.map((item) => item.keyword)}
                // isOptionEqualToValue={(option, value) => option.label === value}
                sx={{ width: 300 }}
                limitTags={2}
                size={"small"}
                onChange={(event: any, newValue: string[] | null) => {
                  // setValue(newValue);
                  setDistribution(newValue as string[]);
                  console.log(newValue);
                }}
                isOptionEqualToValue={(option, value) => option === value}
                // disableClearable
                value={distribution as string[]}
                renderInput={(params) => (
                  <TextField {...params} label="Select Keywords" />
                )}
              />
            )}
          </div>
        </div>

        <div style={{ width: "100%" }}>
          <>
            {loading && (
              <AreaLineChart
                chartData={[]}
                // labels={chartData.labels}
                xLabel={propertyName}
                yLabel={"Count"}
                xAxisDateTime={type === "timeSeries"}
              />
            )}
            {!loading && error === null && distribution?.length === 0 && (
              <div className="alertContainer">
                <Alert severity="error">Please Select Keyword</Alert>
              </div>
            )}
            {chartData &&
              !loading &&
              error === null &&
              Array.isArray(distribution) &&
              (type !== "timeSeries" ? (
                <AreaLineChart
                  chartData={
                    chartData === null ? [] : (chartData.data as any[])
                  }
                  // labels={chartData.labels}
                  xLabel={propertyName}
                  yLabel={"Count"}
                  xAxisDateTime={false}
                  type={"line"}
                  xAxisOffset={85}
                />
              ) : (
                <AreaLineChart
                  chartData={
                    chartData === null ? [] : (chartData.data as any[])
                  }
                  // labels={chartData.labels}
                  xLabel={propertyName}
                  yLabel={"Count"}
                  xAxisDateTime={type === "timeSeries"}
                />
              ))}
          </>
          {getChartBottomIcons(showMaxButton, setOpen)}
          {type !== "timeSeries"
            ? getChartInfoIcons(desc["twitter"]["yearAnalysis"])
            : getChartInfoIcons(desc["twitter"]["interestOverTime"])}
        </div>
      </Paper>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
